import { render, staticRenderFns } from "./notification-panel.vue?vue&type=template&id=463a8f8b&scoped=true&"
import script from "./notification-panel.vue?vue&type=script&lang=js&"
export * from "./notification-panel.vue?vue&type=script&lang=js&"
import style0 from "./notification-panel.vue?vue&type=style&index=0&id=463a8f8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a8f8b",
  null
  
)

export default component.exports